import React, { useState } from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import { useSwipeable } from 'react-swipeable';

interface SwipeableBoxProps extends BoxProps {
    onSwipeEnded: (direction: string) => void;
    children?: React.ReactNode;
    bgcolor?: string;
}

function SwipeableBox(props: SwipeableBoxProps) {
    const [swipeDirection, setSwipeDirection] = useState<string | null>(null);

    const handlers = useSwipeable({
        delta: 5,
        onSwiped: ({ dir, deltaX, deltaY }) => {
            if (Math.abs(deltaX) > Math.abs(deltaY)) {
                setSwipeDirection(dir === 'Left' ? 'left' : 'right');
                props.onSwipeEnded(dir === 'Left' ? 'left' : 'right');
                setTimeout(() => setSwipeDirection(null), 400);
            }
        },
        trackMouse: true,
    });

    return (
        <Box
            {...props}
            {...handlers}
            sx={{
                ...props.sx,
                backgroundColor: swipeDirection
                    ? swipeDirection === 'left'
                        ? 'red'
                        : 'green'
                    : props.bgcolor,
                transition: 'transform 0.4s ease, background-color 0.4s ease',
                transform:
                    swipeDirection === 'left'
                        ? 'translateX(-20%)'
                        : swipeDirection === 'right'
                            ? 'translateX(20%)'
                            : 'translateX(0)',
                /* boxShadow: swipeDirection ? '0px 4px 12px rgba(0, 0, 0, 0.2)' : 'none', */
                width: '100%',
                borderRadius: '8px'
            }}
        >
            {props.children}
        </Box>
    );
}

export default SwipeableBox;